import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import RichTextEditor from "@/components/RichTextEditor";
import { Field, TextInput } from "@/components/Field";

export default function SettingsPanel() {
  const { reload } = useSite();
  const [form, setForm] = useState(null);
  const [disc, setDisc] = useState("");
  const [busy, setBusy] = useState(false);
  const [editorKey, setEditorKey] = useState(0);

  useEffect(() => {
    api.get("/admin/settings").then(({ data }) => {
      setForm(data);
      setDisc(data.disclaimer_html || "");
      setEditorKey((k) => k + 1);
    });
  }, []);

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async () => {
    setBusy(true);
    try {
      await api.put("/admin/settings", { ...form, disclaimer_html: disc });
      await reload();
      toast.success("Settings saved and live.");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Could not save.");
    } finally { setBusy(false); }
  };

  if (!form) return <p className="font-body text-brand-slate">Loading…</p>;

  return (
    <div className="max-w-2xl rounded-3xl bg-white border border-brand-line p-6 md:p-8 space-y-6">
      <div className="grid sm:grid-cols-2 gap-5">
        <Field label="Business name"><TextInput value={form.business_name || ""} onChange={upd("business_name")} data-testid="set-business" /></Field>
        <Field label="Location"><TextInput value={form.location || ""} onChange={upd("location")} data-testid="set-location" /></Field>
        <Field label="Displayed email (shown on site)"><TextInput value={form.email_display || ""} onChange={upd("email_display")} data-testid="set-email-display" /></Field>
        <Field label="Actual email (where messages go)"><TextInput value={form.email || ""} onChange={upd("email")} data-testid="set-email" /></Field>
        <Field label="Phone"><TextInput value={form.phone || ""} onChange={upd("phone")} data-testid="set-phone" /></Field>
      </div>
      <div>
        <p className="font-body text-sm text-brand-slate mb-2">Footer disclaimer</p>
        <RichTextEditor key={editorKey} value={disc} onChange={setDisc} />
      </div>
      <button onClick={save} disabled={busy} data-testid="save-settings-btn" className="inline-flex items-center gap-2 rounded-full bg-brand-forest text-white px-6 py-3 font-body text-sm hover:bg-brand-forest-dark disabled:opacity-60">
        <Save size={16} strokeWidth={1.5} /> {busy ? "Saving…" : "Save settings"}
      </button>
    </div>
  );
}
